import Modal from '@web-ui-kit/modal'

import Text from '@web-ui-kit/text'
import * as Sc from '../Modals.styles'
import i18n from 'i18n'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import { useWindowDimensions } from 'hooks'
import { isMobile } from 'utils/rebrandingUtils'

const ModalConfirmSendActivity = () => {
  const { store, hideModal } = useGlobalModalContext()
  const { modalProps } = store || {}
  const { body, onCancel, onConfirm, onConfirmText } = modalProps || {}

  const { width: windowWidth } = useWindowDimensions()

  return (
    <Modal
      buttons={{
        contained: onConfirm
          ? {
              disabled: false,
              label: onConfirmText,
              onClick: onConfirm,
            }
          : undefined,
        outlined: onCancel
          ? {
              disabled: false,
              label: i18n.t('Seguir editando'),
              onClick: onCancel,
            }
          : undefined,
      }}
      handleCloseModal={hideModal}
      id='modal-confirm-send-activity'
      isSmall={isMobile(windowWidth)}
      topNav={{
        enableCloseIcon: isMobile(windowWidth),
      }}
    >
      <Sc.ModalActivityContainer isFullscreen={isMobile(windowWidth)}>
        <Text component='span' variant='body'>
          {body}
        </Text>
      </Sc.ModalActivityContainer>
    </Modal>
  )
}

export default ModalConfirmSendActivity
